import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { IonContent } from '@ionic/angular';

@Component({
  selector: 'app-elipsis-modal',
  templateUrl: './elipsis-modal.component.html',
  styleUrls: ['./elipsis-modal.component.scss'],
})
export class ElipsisModalComponent implements OnInit, AfterViewInit {

  @Input() isModal;
  @Input() descripcion;
  @ViewChild('content') private content: IonContent;
  arrayComentarios: string[] = [];

  constructor() { }

  ngAfterViewInit(): void {
    this.scrollToBottomOnInit();
  }

  ngOnInit() {
    this.arrayComentarios = this.descripcion.split('\n');
  }

  scrollToBottomOnInit() {
    setTimeout(() => {
      this.content.scrollToBottom(300);
    }, 500);
  }

}
